import { oidcClient } from '@/services/oidcClient';

let zClient: any;

if (zClient === undefined) {
  // @ts-ignore
  const zaf: any = ZAFClient.init();
  if (zaf !== false) {
    let ticketContext: any;
    (async () => {
      ticketContext = await zaf.context();
    })();

    zClient = {};

    const exec = <T, Fn extends (...args: any[]) => Promise<T>>(callback: Fn) => {
      return async (...callbackArgs: Parameters<Fn>): Promise<T> => {
        try {
          return await callback(...callbackArgs);
        } catch (err: any) {
          throw {
            ticketId: ticketContext?.ticketId,
            userEmail: oidcClient?.userProfile?.email,
            requestParams: JSON.stringify(callbackArgs),
            originalError: err,
          };
        }
      };
    };

    // zClient.request
    zClient.request = exec((options: any): Promise<any> => zaf.request(options));

    // zClient.authorizedRequest
    zClient.authorizedRequest = exec((options: any): Promise<any> =>
      zaf.request({
        ...options,
        headers: {
          Authorization: `Bearer ${oidcClient.accessToken}`,
          'Content-Type': 'application/json',
          ...options.headers,
        },
      })
    );

    // zClient.get
    zClient.get = exec((...args: any[]): Promise<any> => zaf.get(...args));

    // zClient.set
    zClient.set = exec((...args: any[]): Promise<any> => zaf.set(...args));

    // zClient.context
    zClient.context = exec((...args: any[]): Promise<any> => zaf.context(...args));

    // zClient.on
    zClient.on = exec((...args: any[]): Promise<any> => zaf.on(...args));

    // zClient.invoke
    zClient.invoke = exec((...args: any[]): Promise<any> => zaf.invoke(...args));

    // zClient.metadata
    zClient.metadata = exec((...args: any[]): Promise<any> => zaf.metadata(...args));

    new Promise<void>((resolve) => {
      try {
        zaf.on('app.registered', () => resolve());
      } catch {
        resolve();
      }
    }).then(() => zaf.invoke('resize', { width: '100%', height: '775px' }));
  }
}

export { zClient };
